import { Card } from 'components/common';
import { Col, Grid } from 'components/common/Grid';
import { CardLoader } from 'components/common/Loading';
import { AppointmentCard } from 'components/views-components/staff/appointments/AppointmentCard';
import { ReactNode } from 'react';
import { FaLightbulb } from 'react-icons/fa';
import { toRemStr } from '../../../utils/helpers';

export type ReportsBodyProps = {
  isLeftCardLoading?: boolean;
  isRightCardLoading?: boolean;
  leftColMD: number;
  leftCardNode: ReactNode;
  rightColMD?: number;
  rightCardNode?: ReactNode;
  rightCardTitle?: string;
  rightCardMinHeight?: string;
  onRightCardClose?: () => unknown;
};

export const ReportsBody = ({
  isLeftCardLoading = false,
  isRightCardLoading = false,
  leftColMD,
  rightColMD,
  leftCardNode,
  rightCardNode,
  rightCardTitle,
  rightCardMinHeight,
  onRightCardClose,
}: ReportsBodyProps) => {
  return (
    <Grid style={{ maxHeight: '100%' }}>
      <Col style={{ maxHeight: '100%' }} md={leftColMD}>
        <Card scroll style={{ minHeight: toRemStr(300) }}>
          {leftCardNode}
          {isLeftCardLoading && <CardLoader fillWrapper={true} />}
        </Card>
      </Col>
      {rightCardNode && (
        <Col style={{ maxHeight: '100%' }} col={rightColMD}>
          <AppointmentCard
            icon={<FaLightbulb />}
            title={rightCardTitle}
            onCloseClicked={onRightCardClose}
            minHeight={rightCardMinHeight}
            scroll
          >
            {rightCardNode}
            {isRightCardLoading && <CardLoader fillWrapper={true} />}
          </AppointmentCard>
        </Col>
      )}
    </Grid>
  );
};
